import MountPointsClass from 'shared/utils/mountPoints'

import useShopAndRuntimeConfig from './useShopAndRuntimeConfig'

const useMountPoints = () => {
  const {
    publicRuntimeConfig: {
      publicConfig: { mountPoints, tenant, language },
      pageProperties: { coreShopEnvironment },
    },
  } = useShopAndRuntimeConfig()

  return new MountPointsClass({
    mountPoints,
    tenant,
    language,
    coreShopEnvironment,
  })
}

export default useMountPoints
